import './ccf-call-merge-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCallMergeIconProps extends SvgIconProps {}

/**
 * Component to display call merger icon
 * @param props - CcfCallMergeIconProps
 * @example <CcfCallMergeIcon />
 * @returns 
 */
export function CcfCallMergeIcon(props: CcfCallMergeIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_merge_call_btn" clip-path="url(#clip-ic_merge_call_btn)">
    <g id="Group_120173" data-name="Group 120173" transform="translate(-258.5 815.5) rotate(-90)">
      <rect id="Rectangle_80377" data-name="Rectangle 80377" width="31" height="31" rx="4" transform="translate(788 255)" fill="none"/>
      <g id="Group_118580" data-name="Group 118580" transform="translate(-30.792 0.088)">
        <path id="Path_13265" data-name="Path 13265" d="M126.966-113.62h4v3.469c0,.6.419.82.926.494l7.756-5a.665.665,0,0,0,0-1.206l-7.75-4.991c-.511-.326-.935-.111-.935.49v3.474h-3.994a1.654,1.654,0,0,0-1.673,1.632A1.654,1.654,0,0,0,126.966-113.62Z" transform="translate(705.229 385.272)" fill="#526b7a"/>
        <rect id="Rectangle_80372" data-name="Rectangle 80372" width="11.494" height="2.554" rx="1.277" transform="translate(825.133 261.222) rotate(45)" fill="#526b7a"/>
        <rect id="Rectangle_80373" data-name="Rectangle 80373" width="11.494" height="2.554" rx="1.277" transform="translate(823.327 277.013) rotate(-45)" fill="#526b7a"/>
      </g>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfCallMergeIcon;
